module.exports = __webpack_public_path__ + "img/Kypho V1 960x540.8aa115be.png";